import DocumentTitle from 'react-document-title'
import Grid from '@material-ui/core/Grid';
import { I18n } from 'react-i18nify-lite'
import React from 'react';
import { withRouter } from 'react-router'
import { withStyles } from '@material-ui/core/styles';

const styles = {
    container: {
        // height: '100vh'
    },
    content: {
        display: 'flex',
        flex: 1,
        overflow: 'auto',
        padding: '12px',
        backgroundColor: '#f7f7f7',
        boxShadow: "0 -2px 0 0 #DDDDDD"
    }
};


const Wrapper = ({ classes, children, user, accounts, currAccount = 0, logout, switchAccount, updateError, updateTime, configurationUpdating, stopUpdateTimer, serial, build, ...other }) => {
    return (
        <DocumentTitle title={I18n.t('wrapper.appTitle')}>
            <Grid container direction="column" alignItems="stretch" spacing={0} className={classes.container}>
                <Grid item>
                    <Header user={user} currAccount={currAccount} accounts={accounts} logout={logout} switchAccount={switchAccount} updateTime={updateTime} configurationUpdating={configurationUpdating} stopUpdateTimer={stopUpdateTimer} updateError={updateError} />
                </Grid>
                <Grid item className={classes.content}>
                    {children}
                </Grid>
                <Grid item>
                    <Footer serial={serial} build={build}/>
                </Grid>
            </Grid>
        </DocumentTitle>
    );
};

export default withStyles(styles, { name: 'Wrapper' })(Wrapper);

const headerStyles = {
    container: {
        backgroundColor: "rgba(0,0,0,0.7)",
        boxShadow: "0 1px 0 0 #DDDDDD",
    },
    logoContainer: {
        '& img': {
            display: "block",
            float: "left",
        }
    },
    navContainer: {
        backgroundColor: '#EEEEEE',
        boxShadow: "0 2px 0 0 #DDDDDD",
        zIndex: 10,
    },
    navLink: {
        color: 'rgba(0,0,0,0.4)',
        textDecoration: "None",
        margin: '5px 50px 0 54px',
        textAlign: 'center',
        paddingTop: '5px'
    },
    navText: {
        textTransform: 'uppercase',
        padding: '5px 0 8px 0',
        fontSize: '12px'
    },
    selectedNavItem: {
        color: 'black',
        boxShadow: "0 2px 0 0 #0088CE"
    }
};

let Header = ({ classes, user, accounts, currAccount, logout, switchAccount, updateError, updateTime, configurationUpdating, stopUpdateTimer }) => {
    return (
        <Grid container spacing={0} className={classes.container}>
            <Grid item xs={12} container spacing={0} justifyContent="center" className={classes.navContainer}>
                {/* <NavLink to="/dashboard" activeClassName={classes.selectedNavItem} className={classes.navLink}>
                    <OverviewIcon />
                    <div className={classes.navText}>
                        <Translate value="navBar.overview" />
                    </div>
                </NavLink> */}
                {/* <NavLink to="/applications" activeClassName={classes.selectedNavItem} className={classes.navLink}>
                    <div className={classes.navText}>
                        <Translate value="navBar.applications" />
                    </div>
                </NavLink> */}

            </Grid>
        </Grid>
    );
};

Header = withRouter(withStyles(headerStyles, { name: 'Header' })(Header));
export { Header };


const footerStyles = {
    container: {
        backgroundColor: '#f7f7f7',
        padding: '5px 15px'
    },
    footer: {
        height: '30px',
    },
    footerText: {
        extend: 'grow',
        lineHeight: '14px',
        color: '#777777',
        fontSize: '12px',
        marginTop: '10px'
    }
};


const FooterComponent = ({ classes, serial, build }) => {
    return (
        <Grid container spacing={0} className={classes.container}>
        </Grid>
    );
}

const Footer = withStyles(footerStyles, { name: 'Footer' })(FooterComponent);
export { Footer };